module.exports = __webpack_public_path__ + "img/Tracking-Solution.c146d72a.jpg";